// src/pages/Residential/Optional/SafetyPlanUrdu/SafetyPlanUrduForm.js
import React from "react";

const SafetyPlanUrduForm = ({ formData, handleChange }) => {
    const sections = [
        {
            id: "warningSigns",
            title: "۱. ۔ انتباہی علامات (خیالات، تصاویر، موڈ، صورتحال، رویہ) جو بحران کی نشاندہی کرتی ہیں:",
            label: "تفصیل درج کریں"
        },
        {
            id: "internalCoping",
            title: "۲. ۔ اندرونی مقابلہ کی حکمت عملیاں – وہ چیزیں جو میں دوسرے شخص سے رابطہ کیے بغیر مسائل سے ذہن ہٹانے کے لیے کر سکتا ہوں:",
            label: "تفصیل درج کریں"
        },
        {
            id: "socialDistractions",
            title: "۳. ۔ لوگ اور سماجی ماحول جو توجہ ہٹانے میں مدد دیتے ہیں:",
            label: "تفصیل درج کریں"
        },
        {
            id: "peopleForHelp",
            title: "۴. ۔ وہ لوگ جن سے میں مدد مانگ سکتا ہوں:",
            label: "تفصیل درج کریں"
        },
        {
            id: "professionals",
            title: "۵. ۔ پیشہ ور افراد یا ایجنسیاں جن سے بحران کے دوران رابطہ کیا جا سکتا ہے:",
            label: "تفصیل درج کریں"
        },
        {
            id: "safeEnvironment",
            title: "۶. ۔ ماحول کو محفوظ بنانا:",
            label: "تفصیل درج کریں"
        },
        {
            id: "reasonsForLiving",
            title: "۷. ۔ زندگی کی وجوہات – وہ ایک چیز جو میرے لیے سب سے اہم ہے اور زندہ رہنے کے قابل ہے:",
            label: "تفصیل درج کریں"
        },
        {
            id: "additionalNotes",
            title: "۸. ۔ اضافی نوٹس / دیگر حکمت عملیاں:",
            label: "تفصیل درج کریں"
        }
    ];

    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>

                <div className="accordion" id="safetyPlanUrduAccordion">
                    {sections.map((section, index) => (
                        <div className="accordion-item mb-3 shadow-sm rounded" key={section.id}>
                            <h2 className="accordion-header">
                                <button
                                    className={`accordion-button fw-semibold ${index === 0 ? "" : "collapsed"}`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#${section.id}`}
                                >
                                    {section.title}
                                </button>
                            </h2>
                            <div
                                id={section.id}
                                className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                            >
                                <div className="accordion-body pt-3">
                                    <div className="form-floating form-floating-outline">
                                        <textarea
                                            className="form-control"
                                            name={section.id}
                                            value={formData[section.id] || ""}
                                            onChange={handleChange}
                                            rows="6"
                                            style={{ height: "160px" }}
                                            dir="auto"
                                        />
                                        <label>{section.label}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default SafetyPlanUrduForm;